import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const HelpIcon = (props) => (
  <SvgIcon {...props}>
    <g>
      <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
        M22,21c0,0-1.12,1-2.5,1S17,21,17,21s-1.12,1-2.5,1S12,21,12,21s-1.12,1-2.5,1S7,21,7,21s-1.12,1-2.5,1S2,21,2,21"/>
      
        <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" strokeMiterlimit="10" x1="8.358" y1="18.265" x2="8.358" y2="21.265"/>
      <g>
        
          <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
          M14,19c1.766-0.772,3-3,3-5v-2V8c0-0.552-0.448-1-1-1c-0.552,0-1,0.448-1,1V4c0-0.552-0.448-1-1-1s-1,0.448-1,1V3
          c0-0.552-0.448-1-1-1s-1,0.448-1,1v1c0-0.552-0.448-1-1-1S9,3.448,9,4v2c0-0.552-0.448-1-1-1S7,5.448,7,6v6v2.333
          c0,2.05,1.234,3.895,3,4.667"/>
        
          <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="9" y1="5.593" x2="9" y2="11"/>
        
          <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="11" y1="4" x2="11" y2="10"/>
        
          <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="13" y1="4" x2="13" y2="9"/>
        
          <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
          M15,8v3.333c-1.657,0-3,0.667-3,2.667"/>
      </g>
    </g>
    <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round" strokeMiterlimit="10" x1="15.64" y1="21.114" x2="15.64" y2="18.114"/>
  </SvgIcon>
);

export default HelpIcon;



// WEBPACK FOOTER //
// ./src/icons/menu/HelpIcon.jsx